var map = {
	"./CodeService.js": "4a6a",
	"./CouponService.js": "e436",
	"./CourseService.js": "c4af",
	"./ExamService.js": "9ab6",
	"./LiveService.js": "e2e2",
	"./ServiceBase.js": "10dc",
	"./ServiceInject.js": "254c"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "aa26";